import { createContext } from "react";

import { LazyValue, useLazyContext } from "~utils";

import { PartialPreferences } from "./preferences";

export function usePreferencesLocalPersistence(): usePreferencesLocalPersistenceReturn {
  return useLazyContext(PreferencesLocalPersistenceContext);
}

export type usePreferencesLocalPersistenceReturn = {
  getPreferences: () => Promise<PartialPreferences>;
  setPreferences: (preferences: PartialPreferences) => Promise<void>;
};

export const PreferencesLocalPersistenceContext =
  createContext<LazyValue<usePreferencesLocalPersistenceReturn>>(undefined);
